export default {
  getErrorFromApiResponse(response) {
    if (!response) return null;

    if (response.errors && response.errors.length) {
      return response.errors[0].message;
    }

    return 'Error';
  }
};



// WEBPACK FOOTER //
// ./src/utils/errorUtils.js